// Regex that handles > inside quoted attribute values
// Matches: <source attr="value with > inside" />
// Note: [a-zA-Z][a-zA-Z0-9_-]* handles camelCase attributes like messageId
// Self-closing tags are tried first, then tags with content
export const SOURCE_TAG_REGEX =
	/<source(?:\s+[a-zA-Z][a-zA-Z0-9_-]*="[^"]*"|\s+[a-zA-Z][a-zA-Z0-9_-]*='[^']*'|\s+[a-zA-Z][a-zA-Z0-9_-]*=[^\s>]*)*\s*\/>|<source(?:\s+[a-zA-Z][a-zA-Z0-9_-]*="[^"]*"|\s+[a-zA-Z][a-zA-Z0-9_-]*='[^']*'|\s+[a-zA-Z][a-zA-Z0-9_-]*=[^\s>]*)*\s*>[\s\S]*?<\/source>/gi;

// A wrapper holding nothing but <source> tags (e.g. the hidden
// <span style="display:none;font-size:0;"> the editor writes) goes away with them.
// Any other empty <span>/<div> is left alone.
const SOURCE_OR_WRAPPED_SOURCES_REGEX = new RegExp(
	`<(span|div)(?:\\s[^>]*)?>\\s*(?:(?:${SOURCE_TAG_REGEX.source})\\s*)+<\\/\\1>|${SOURCE_TAG_REGEX.source}`,
	"gi",
);

export function cleanSourceTags(text: string, replaceSourceTagWithMarker = false): string {
	let sourceCount = 0;

	const replaceSource = () => {
		sourceCount += 1;

		return replaceSourceTagWithMarker ? `⟦S${sourceCount}⟧` : "";
	};

	return text
		.replace(SOURCE_OR_WRAPPED_SOURCES_REGEX, (match) =>
			match.startsWith("<source")
				? replaceSource()
				: Array.from(match.matchAll(SOURCE_TAG_REGEX), replaceSource).join(""),
		)
		.replace(/<hr\s*\/?>/gi, "---");
}
